<div class="container-fluid reset-password">
  <div class="row">
    <div class="col-12 box-bg-top">
      <form
        [formGroup]="resetPasswordForm"
        (ngSubmit)="resetPassword()"
        autocomplete="none"
      >
        <div class="form-container">
          @if (showResetPasswordForm && !hideResetPasswordForm) {
            <div class="box-logo">
              <img class="fpool-logo" src="assets/img/fpool-logo.png" />
              <br />
              <img class="key-icon" src="assets/img/ic_LockKey.png" />
              <br />
              <span class="title">Change Your Password</span>
            </div>
          }
          @if (showResetPasswordForm && showSuccessMessage) {
            <div class="box-logo">
              <img class="fpool-logo" src="assets/img/fpool-logo.png" />
              <br />
              <br />
              <br />
              <span class="title">{{
                "lang.password_updated" | translate
              }}</span>
              <div class="success-message">
                {{ "lang.password_updated_success_msg" | translate }}
              </div>
            </div>
          }
          @if (showResetPasswordForm && !hideResetPasswordForm) {
            <div class="input-box">
              <label>New Password</label>
              <div
                class="input-group"
                [ngClass]="
                  resetPasswordFormControl['newPassword'].hasError(
                    'length_zero'
                  )
                    ? 'border-black'
                    : resetPasswordFormControl['newPassword'].invalid
                      ? 'border-red'
                      : 'border-black'
                "
              >
                <div class="input-group-prepend">
                  <button type="button" class="btn btn-default">
                    <img
                      [ngClass]="
                        resetPasswordFormControl['newPassword'].hasError(
                          'length_zero'
                        )
                          ? 'key-hole-img'
                          : 'key-hole-img-active'
                      "
                      alt="Password Icon"
                    />
                  </button>
                </div>
                <input
                  [type]="newPasswordInputType"
                  (focus)="isPasswordfieldFocused = true"
                  (blur)="isPasswordfieldFocused = false"
                  class="form-control"
                  placeholder="Password"
                  formControlName="newPassword"
                />
                <div class="input-group-btn">
                  <button
                    type="button"
                    class="btn btn-default"
                    (click)="showHidePasswordText()"
                  >
                    <img
                      [ngClass]="
                        newPasswordInputType === 'text'
                          ? resetPasswordFormControl['newPassword'].hasError(
                              'length_zero'
                            )
                            ? 'fa-eye'
                            : 'fa-eye-active'
                          : resetPasswordFormControl['newPassword'].hasError(
                                'length_zero'
                              )
                            ? 'fa-eye-slash'
                            : 'fa-eye-slash-active'
                      "
                      alt="Password Icon"
                    />
                  </button>
                </div>
              </div>
              @if (
                isConfirmPasswordfieldFocused &&
                resetPasswordFormControl["newPassword"].hasError("required")
              ) {
                <span class="new-pass-validation red mt-2">
                  Enter your password.
                </span>
              }
              @if (
                isPasswordfieldFocused ||
                (!resetPasswordFormControl["newPassword"].hasError(
                  "length_zero"
                ) &&
                  !resetPasswordFormControl["newPassword"].valid)
              ) {
                <span
                  class="new-pass-validation mt-3"
                  [ngClass]="
                    resetPasswordFormControl['newPassword'].hasError(
                      'length_zero'
                    )
                      ? 'black'
                      : resetPasswordFormControl['newPassword'].hasError(
                            'min_length'
                          )
                        ? 'red'
                        : 'green'
                  "
                >
                  <i
                    class="fa"
                    [ngClass]="
                      resetPasswordFormControl['newPassword'].hasError(
                        'length_zero'
                      )
                        ? 'invalid-icon-black'
                        : resetPasswordFormControl['newPassword'].hasError(
                              'min_length'
                            )
                          ? 'invalid-icon'
                          : 'valid-icon'
                    "
                    aria-hidden="true"
                  ></i>
                  8 characters minimum
                </span>
                <span
                  class="new-pass-validation"
                  [ngClass]="
                    resetPasswordFormControl['newPassword'].hasError(
                      'length_zero'
                    )
                      ? 'black'
                      : resetPasswordFormControl['newPassword'].hasError(
                            'no_upper_case'
                          )
                        ? 'red'
                        : 'green'
                  "
                >
                  <i
                    class="fa"
                    [ngClass]="
                      resetPasswordFormControl['newPassword'].hasError(
                        'length_zero'
                      )
                        ? 'invalid-icon-black'
                        : resetPasswordFormControl['newPassword'].hasError(
                              'no_upper_case'
                            )
                          ? 'invalid-icon'
                          : 'valid-icon'
                    "
                    aria-hidden="true"
                  ></i>
                  One uppercase letter
                </span>
                <span
                  class="new-pass-validation"
                  [ngClass]="
                    resetPasswordFormControl['newPassword'].hasError(
                      'length_zero'
                    )
                      ? 'black'
                      : resetPasswordFormControl['newPassword'].hasError(
                            'no_lower_case'
                          )
                        ? 'red'
                        : 'green'
                  "
                >
                  <i
                    class="fa"
                    [ngClass]="
                      resetPasswordFormControl['newPassword'].hasError(
                        'length_zero'
                      )
                        ? 'invalid-icon-black'
                        : resetPasswordFormControl['newPassword'].hasError(
                              'no_lower_case'
                            )
                          ? 'invalid-icon'
                          : 'valid-icon'
                    "
                    aria-hidden="true"
                  ></i>
                  One lowercase letter
                </span>
                <span
                  class="new-pass-validation"
                  [ngClass]="
                    resetPasswordFormControl['newPassword'].hasError(
                      'length_zero'
                    )
                      ? 'black'
                      : resetPasswordFormControl['newPassword'].hasError(
                            'no_number'
                          )
                        ? 'red'
                        : 'green'
                  "
                >
                  <i
                    class="fa"
                    [ngClass]="
                      resetPasswordFormControl['newPassword'].hasError(
                        'length_zero'
                      )
                        ? 'invalid-icon-black'
                        : resetPasswordFormControl['newPassword'].hasError(
                              'no_number'
                            )
                          ? 'invalid-icon'
                          : 'valid-icon'
                    "
                    aria-hidden="true"
                  ></i>
                  One number
                </span>
                <span
                  class="new-pass-validation"
                  [ngClass]="
                    resetPasswordFormControl['newPassword'].hasError(
                      'length_zero'
                    )
                      ? 'black'
                      : resetPasswordFormControl['newPassword'].hasError(
                            'no_special_chars'
                          )
                        ? 'red'
                        : 'green'
                  "
                >
                  <i
                    class="fa"
                    [ngClass]="
                      resetPasswordFormControl['newPassword'].hasError(
                        'length_zero'
                      )
                        ? 'invalid-icon-black'
                        : resetPasswordFormControl['newPassword'].hasError(
                              'no_special_chars'
                            )
                          ? 'invalid-icon'
                          : 'valid-icon'
                    "
                    aria-hidden="true"
                  ></i>
                  One character !&#64;#$%^&*
                </span>
              }
            </div>
            <div class="input-box">
              <label>Confirm Password</label>
              <div
                class="input-group"
                [ngClass]="
                  resetPasswordFormControl['confirmPassword'].dirty &&
                  resetPasswordForm.hasError('no_matching_pass')
                    ? 'border-red'
                    : 'border-black'
                "
              >
                <div class="input-group-prepend">
                  <button type="button" class="btn btn-default">
                    <img
                      [ngClass]="
                        resetPasswordForm.hasError('length_zero')
                          ? 'key-hole-img'
                          : 'key-hole-img-active'
                      "
                      class="key-hole-img"
                      alt="Password Icon"
                    />
                  </button>
                </div>
                <input
                  [type]="confirmPasswordInputType"
                  (focus)="isConfirmPasswordfieldFocused = true"
                  (blur)="isConfirmPasswordfieldFocused = false"
                  class="form-control"
                  placeholder="Password"
                  formControlName="confirmPassword"
                />
                <div class="input-group-btn">
                  <button
                    type="button"
                    class="btn btn-default"
                    (click)="showHidePasswordText()"
                  >
                    <img
                      [ngClass]="
                        newPasswordInputType === 'text'
                          ? resetPasswordForm.hasError('length_zero')
                            ? 'fa-eye'
                            : 'fa-eye-active'
                          : resetPasswordForm.hasError('length_zero')
                            ? 'fa-eye-slash'
                            : 'fa-eye-slash-active'
                      "
                      alt="Password Icon"
                    />
                  </button>
                </div>
              </div>
              @if (resetPasswordFormControl["confirmPassword"].dirty) {
                @if (resetPasswordForm.hasError("no_matching_pass")) {
                  <span class="new-pass-validation red mt-2">
                    Password doesn't match
                  </span>
                }
              }
            </div>
            <div class="input-box">
              <button
                type="submit"
                class="btn btn-primary"
                [disabled]="!resetPasswordForm.valid"
                [ngClass]="{
                  disabled: !resetPasswordForm.valid,
                  enabled: resetPasswordForm.valid,
                }"
              >
                Update
              </button>
            </div>
          }
        </div>
      </form>
    </div>
  </div>
</div>
